import actionTypes from '../../utilities/actionTypes';
export interface IFetchAgents {
  type: actionTypes.FETCH_AGENTS;
}
export interface IFetchAgentsPending {
  type: actionTypes.FETCH_AGENTS_PENDING;
}
export interface IFetchAgentsSuccess {
  type: actionTypes.FETCH_AGENTS_SUCCESS;
  payload: any;
}

export interface IFetchAgentsCancel {
  type: actionTypes.FETCH_AGENTS_CANCEL;
}
export interface IFetchAgentsCancel {
  type: actionTypes.FETCH_AGENTS_CANCEL;
}

export interface IAddAgent {
  type: actionTypes.ADD_AGENT;
  payload: any;
}

export interface IUpdateAgent {
  type: actionTypes.UPDATE_AGENT;
  payload: any;
}
export interface IUpdateAgentSuccess {
  type: actionTypes.UPDATE_AGENT_SUCCESS;
  payload: any;
}
export interface IUpdateAgentSuccess {
  type: actionTypes.UPDATE_AGENT_SUCCESS;
  payload: any;
}

export interface IFetchSkynetConfig {
  type: actionTypes.FETCH_SKYNET_CONFIG;
}
export interface IFetchSkynetConfigSuccess {
  type: actionTypes.FETCH_SKYNET_SUCCESS;
  payload: any;
}

export interface IUpdateSkynetConfig {
  type: actionTypes.UPDATE_SKYNET_CONFIG;
  payload: any;
}
export interface IUpdateSkynetConfigSuccess {
  type: actionTypes.UPDATE_SKYNET_CONFIG_SUCCESS;
  payload: any;
}

export interface IDeleteAgent {
  type: actionTypes.DELETE_AGENT;
  customer: string;
}

export interface IDeleteAgentSuccess {
  type: actionTypes.DELETE_AGENT_SUCCESS;
  customer: string;
}

export const fetchAgents = (): IFetchAgents => {
  return {
    type: actionTypes.FETCH_AGENTS
  };
};
export const fetchAgentsPending = (): IFetchAgentsPending => {
  return {
    type: actionTypes.FETCH_AGENTS_PENDING
  };
};

export const fetchAgentsSuccess = (payload: any): IFetchAgentsSuccess => {
  return {
    type: actionTypes.FETCH_AGENTS_SUCCESS,
    payload
  };
};
export const fetchAgentsCancel = (): IFetchAgentsCancel => {
  return {
    type: actionTypes.FETCH_AGENTS_CANCEL
  };
};

export const addAgent = (payload: any): IAddAgent => {
  return {
    type: actionTypes.ADD_AGENT,
    payload
  };
};

export const updateAgent = (payload: any): IUpdateAgent => {
  return {
    type: actionTypes.UPDATE_AGENT,
    payload
  };
};
export const updateAgentSuccess = (payload: any): IUpdateAgentSuccess => {
  return {
    type: actionTypes.UPDATE_AGENT_SUCCESS,
    payload
  };
};

export const fetchSkynetConfig = (): IFetchSkynetConfig => {
  return {
    type: actionTypes.FETCH_SKYNET_CONFIG
  };
};
export const fetchSkynetConfigSuccess = (
  payload: any
): IFetchSkynetConfigSuccess => {
  return {
    type: actionTypes.FETCH_SKYNET_SUCCESS,
    payload
  };
};
export const updateSkynetConfig = (payload: any): IUpdateSkynetConfig => {
  return {
    type: actionTypes.UPDATE_SKYNET_CONFIG,
    payload
  };
};
export const updateSkynetConfigSuccess = (
  payload: any
): IUpdateSkynetConfigSuccess => {
  return {
    type: actionTypes.UPDATE_SKYNET_CONFIG_SUCCESS,
    payload
  };
};

export const deleteAgent = (customer: any): IDeleteAgent => {
  return {
    type: actionTypes.DELETE_AGENT,
    customer
  };
};
export const deleteAgentSuccess = (customer: any): IDeleteAgentSuccess => {
  return {
    type: actionTypes.DELETE_AGENT_SUCCESS,
    customer
  };
};
export type IAgentAction =
  | IFetchAgents
  | IFetchAgentsSuccess
  | IFetchAgentsPending
  | IFetchAgentsCancel
  | IUpdateAgent
  | IUpdateAgentSuccess
  | IFetchSkynetConfig
  | IFetchSkynetConfigSuccess
  | IUpdateSkynetConfig
  | IUpdateSkynetConfigSuccess
  | IDeleteAgent
  | IDeleteAgentSuccess;
